<template>
  <div>
    <v-container>
      <v-card class="mx-auto rounded-lg mt-5" elevation="0" outlined>
        <v-card-text class="secondary-font pa-3">
          <v-container class="mt-3">
            <v-row>
              <v-col cols="12" class="mb-0 pb-0">
                <v-select
                  :items="studentsList"
                  :item-text="
                    (item) =>
                      `${item.currentOptionProgramName} ${item.studyingPeriod}`
                  "
                  item-value="id"
                  v-model="studentId"
                  outlined
                  dense
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-container>
    <v-container>
      <div
        class="d-sm-flex d-xs-block justify-space-between align-center text-center"
      >
        <h1 class="primary--text">Manage Academic Procedures</h1>
        <v-btn
          color="secondary"
          dark
          class="text-capitalize mt-2"
          elevation="0"
          :to="{ name: 'createAcademicProcedure', params: { id: studentId } }"
        >
          Create New Academic Procedure
        </v-btn>
      </div>
      <v-card class="mx-auto rounded-lg mt-5" elevation="0" outlined>
        <v-card-text class="secondary-font pa-3">
          <v-data-table
            class="data-table"
            :headers="headers"
            :items="academicProceduresList"
            :footer-props="{
              itemsPerPageOptions: [10, 25, 50, 100],
            }"
            :disable-sort="true"
            dense
            @click:row="
              (item) => {
                if (item.status === 'Pending Payment') {
                  $router.push({
                    name: 'editAcademicProcedure',
                    params: { uuid: item.id },
                  });
                } else {
                  $router.push({
                    name: 'academicProcedurePayments',
                    params: { uuid: item.id },
                  });
                }
              }
            "
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon color="darkGray" v-bind="attrs" v-on="on" exact>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list dense class="secondary-font list-compressed">
                  <v-list-item
                    exact
                    :to="{
                      name: 'editAcademicProcedure',
                      params: { uuid: item.id },
                    }"
                    v-if="item.status === 'Pending Payment'"
                  >
                    <v-list-item-content>
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item
                    exact
                    :to="{
                      name: 'academicProcedurePayments',
                      params: { uuid: item.id },
                    }"
                  >
                    <v-list-item-title>Payments</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import academicProceduresService from "@/services/academic-procedures-service";
import studentsService from "@/services/students-service";

export default {
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "name",
          class: "primary--text",
        },
        {
          text: "Product",
          value: "productName",
          class: "primary--text",
        },
        {
          text: "Shipment",
          value: "shipmentName",
          class: "primary--text",
        },
        {
          text: "Status",
          value: "status",
          class: "primary--text",
        },
        { value: "actions" },
      ],
      academicProceduresList: [],
      academicProceduresService,
      studentsList: [],
      studentId: null,
    };
  },
  mounted() {
    this.getCrmStudentsList();
  },
  watch: {
    studentId() {
      this.getAcademicProcedures();
    },
  },
  methods: {
    getAcademicProcedures() {
      academicProceduresService
        .getAcademicProcedures(this.studentId)
        .then((response) => {
          this.academicProceduresList = response.data;
        });
    },
    getCrmStudentsList() {
      studentsService.getCrmStudentsList().then((response) => {
        this.studentsList = response.data;
        this.studentId =
          this.studentsList.length > 0 ? this.studentsList[0].id : null;
      });
    },
  },
};
</script>
